import React from 'react';
import { ThemeProvider } from './context/ThemeContext';
import AppRouter from './AppRouter';
export function App() {
  return <ThemeProvider data-id="element-0">
      <AppRouter data-id="element-1" />
    </ThemeProvider>;
}